var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * Asynchronously loads the component for AppAdminDetails
 *
 */
import PageLoader from '@project/components/Loaders/PageLoader';
import { lazy, Suspense } from 'react';
var AppAdminDetailsPage = lazy(function () { return import(/* webpackChunkName: "AppAdminDetailsPage" */ './index'); });
export default function AppAdminDetailsPageLoader(props) {
    return (_jsx(Suspense, __assign({ fallback: _jsx(PageLoader, {}) }, { children: _jsx(AppAdminDetailsPage, __assign({}, props)) })));
}
